__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "NZ-chubb-adviser-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "20.3.27", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(351), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(47172))))));
			register("@angular/common/http", "20.3.27", () => (Promise.all([__webpack_require__.e(737), __webpack_require__.e(332), __webpack_require__.e(129), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(46443))))));
			register("@angular/common", "20.3.27", () => (Promise.all([__webpack_require__.e(737), __webpack_require__.e(332), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(60316))))));
			register("@angular/core", "20.3.27", () => (Promise.all([__webpack_require__.e(737), __webpack_require__.e(580)]).then(() => (() => (__webpack_require__(37580))))));
			register("@angular/forms", "20.3.27", () => (Promise.all([__webpack_require__.e(737), __webpack_require__.e(332), __webpack_require__.e(482), __webpack_require__.e(456)]).then(() => (() => (__webpack_require__(34456))))));
			register("@angular/platform-browser", "20.3.27", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(482), __webpack_require__.e(230), __webpack_require__.e(80), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))));
			register("@angular/router", "20.3.27", () => (Promise.all([__webpack_require__.e(737), __webpack_require__.e(332), __webpack_require__.e(129), __webpack_require__.e(482), __webpack_require__.e(115), __webpack_require__.e(72), __webpack_require__.e(581)]).then(() => (() => (__webpack_require__(95072))))));
			register("@lexical/history", "0.33.0", () => (__webpack_require__.e(226).then(() => (() => (__webpack_require__(4845))))));
			register("@lexical/rich-text", "0.33.0", () => (Promise.all([__webpack_require__.e(778), __webpack_require__.e(890)]).then(() => (() => (__webpack_require__(3778))))));
			register("@ngneat/helipopper", "9.2.1", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(129), __webpack_require__.e(482), __webpack_require__.e(883), __webpack_require__.e(473), __webpack_require__.e(830)]).then(() => (() => (__webpack_require__(59473))))));
			register("lodash-es", "4.18.1", () => (__webpack_require__.e(381).then(() => (() => (__webpack_require__(50381))))));
			register("ngx-mask", "18.0.4", () => (Promise.all([__webpack_require__.e(332), __webpack_require__.e(482), __webpack_require__.e(972), __webpack_require__.e(769), __webpack_require__.e(509)]).then(() => (() => (__webpack_require__(86769))))));
			register("pubsub-js", "1.9.5", () => (__webpack_require__.e(52).then(() => (() => (__webpack_require__(28052))))));
			register("rxjs", "7.8.2", () => (Promise.all([__webpack_require__.e(129), __webpack_require__.e(845), __webpack_require__.e(221)]).then(() => (() => (__webpack_require__(80845))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};